export default __webpack_public_path__ + "static/media/5.e63fd1cd.jpg";